export const CLUE = [
  'Every day is a new one!',
  'Don’t do it later, do it ____!',
  '“You’ve got a ___ in me!”',
  'Monopoly, Clue, Candy Land',
  'Chase, PNC, Wells Fargo',
  'It’s a cold month!',
  '“Don’t worry, be _____!”',
  'It’s used to make smoothies!',
  'Do you like yours scrambled?',
  'That was awful! _____ again!',
  'Jenna Ortega is only 21. She’s _____!',
  'Out with the old and in with the _____!',
  'A-line, pencil, and high waist are types!',
  'He’s NOT joking! He’s __!',
  'Summer break month! Woo-hoo!',
  'Sometimes it’s hard to get out of bed on a _____.',
  'Baked, fried, and grilled are ways to make this!',
  'Sand, water, sun!',
  'mozzarella, cheddar, ricotta, feta',
  'Sit down in this!',
  'A Christmas color!',
  '_____ showers bring May flowers!',
  'Opposite of clean!',
  'Spanish is your favorite _____!',
  'Chihuahua, poodle, goldendoodle',
  'Get out a sheet of _____, please.',
  'Fourth of _____',
  'Not true!',
  'Give me a high _____!',
  'Group of gals!',
  'Helps keep the sun out of your eyes!',
  'Wash your _____ before dinner!',
  'Your headphones go here to hear!',
  'Baa! Baa!',
  'In Mexico, they often put mayo on it!',
  'Arnold Schwarzenegger is not young, he’s _____.',
  'Opposite of ugly!',
  'Gotta have it for your cereal!',
  'Do you like it a little or _____?',
  'They swing from trees!',
  'Listen to your mother and _____!',
  '_____, water, earth, air',
  'A VERY popular Mexican dip!',
  'Let’s go sledding in it!',
  'You use it to go fishing, sailing, or waterskiing!',
  'Teachers give this to you…you’re not a fan!',
  'How you’d address someone older than you.',
  'Wear it with a tie!',
  'Your home address includes this.',
  'It’s smaller than a horse.',
  'Need ’em to play the piano!',
  'I’m sure you take lots with your phone!',
  'The capital of Argentina: Buenos _____',
  'What you do when you get chased by a bear!',
  'People who are 6’3” are often thought of as this.',
  'What your teacher does if you don’t do your homework!',
  'You bury your friends in this at the beach!',
  'You love to send and receive one!',
  'Reptiles, gorillas, and tigers live here!',
  'JLo does this very well!',
  'Ella _____ inglés y español.',
  'If it’s too hot,you might drop it and it could break!',
  'Sometimes something is not that ____.',
  'This times itself is 81!',
  'There are 12 of these in a year!',
  '“Near, _____, wherever you are!”',
  'Los pingüinos _____ en La Antártida.',
  'A turtle walks like this.',
  'The Bahamas are a series of these!',
  'Ella _____ algo en el sitio de Amazon.',
  '“_____ luego!”',
  '“¿Cómo estás?” / “_____ bien, gracias”.',
  'Sly as a _____!',
  'You can play this as singles or doubles!',
  'Not rough, but _____.',
  '¿_____ Netflix mucho?',
  'Used in baseball!',
  'The end!',
  'No quiero _____ la tarea.',
  '¡Ellos _____ mucho para ver el concierto de Taylor Swift! (But it was worth it! Jaja)',
  'Holiday Inn, Hyatt, Marriott',
  'Fish do this!',
  '=',
  'How old is your _____ brother? You have a younger one too, right? ',
  'The opposite of south!',
  'Los estudiantes le _____ “¡Hola!” a la profesora.',
  'There are _____ days in a week!',
  'Oink, oink!',
  '¡A los niños les gusta _____ Happy Meals!',
  'El perro _____ a su casa.',
  'Me gusta mucho _____ en mis bebidas porque me gusta cuando están frías. ',
  'Yo _____ mis libros y lápices en mi mochila.',
  'Es importante _____ la ropa.',
  'Listen to your _____ and father!',
  'Salmon, walleye, trout, and halibut are types!',
  'Barbie’s hair color!',
  'Los meseros _____ la comida.',
  'Quiero _____ una vida excelente.',
  'El hijo de mi tío es mi _____.',
  'I love a good YouTube _____!',
  'Nosotros _____ los papeles al profesor.',
  '¿Quieres _____ un refresco?',
  'I love to dance to the _____ of the drums!',
  'El opuesto (opposite) de entrar.',
  'Es J.K. Rowling _____ escribe los libros de Harry Potter.',
  'Yo _____ tocar el piano.',
  'Billy Joel plays this!',
  'I like to put things in _____.',
  'Need ’em in order to rain!',
  '¡Los Leones _____ muchos partidos de fútbol!',
  '“Shall I compare thee to a summer’s day?”',
  'Las langostas (lobsters) son _____.',
  'These fruits get rounder and heavier toward the bottom!',
  "Pinocchio's grew when he told a lie!",
  'Voy a _____ el autobús a la escuela.',
  '¡Tengo _____ de los monstruos!',
  'Need it to unlock something!',
  'A unit of weight in many countries.',
  'If you are creative, you always have lots of new ones!',
  '“Leer” is the action you do with one of these!',
  'It’s good to have a good one of these for friends!',
  'Voy a _____ la ventana.',
  '¡No hay _____ como (like) tú!',
  'Santa is a little this (because of all the cookies)!',
  'Es bueno tener tiempo _____ en clase.',
  'Messi es el _____ jugador de fútbol.',
  'El libro de Don Quijote es muy _____.',
  'If it’s wrong, correct it!',
  'It’s OK to ask for it!',
  'Jalapeños are hot ones!',
  '_____ you and me, I think he has a crush on her!',
  'The opposite of motivated.',
  'Wear them to help you see!',
  'Cock-a-doodle-doo!',
  'It’s important to obey them!',
  'If you pull a rabbit out of a hat, you know how to do this!',
  '¿Qué vas a _____ en el restaurante?',
  'A woman monarch!',
  '¡Nosotros _____ estudiantes increíbles!!',
  'Better _____ than never!',
  'If you see one, swat it!',
  'Quiero aprender a _____ el piano.',
  'Jenna Ortega is _____ than Lady Gaga.',
  'Part of speech that shows an action.',
  'I’d like one with lots of syrup, please!',
  'A little red fruit!',
  'You sit at them in the cafeteria!',
  'Meow! Meow!',
  'Bonito',
  '¿Quieres _____ a mi partido de fútbol?',
  'I want to take one to Hawaii!',
  'Ella _____ en el coro.',
  'Opposite of arriba!',
  'JLo is a famous one!',
  'El restaurante es _____ vamos a comer hoy.',
  'Opposite of salty!',
  'You flex this to show off your muscles!',
  'It’s important to eat a good one of these!',
  'Opposite of malo!',
  '¡Nosotros _____ a la playa en el verano!',
  'We eat these on Thanksgiving!',
  'The Louvre is a famous one for art!',
  'enero, febrero, _____',
  'A green, prickly plant in the desert!',
  'That was a really _____ joke!',
  'China has the most in the world!',
  '¿Ustedes _____ la respuesta a la pregunta?',
  'Time of day the stars come out!',
  'Opposite of cold!',
  'You need it to tell time!',
  '¡Nosotros _____ una montaña en la distancia!',
  'In Antarctica, it’s cold!',
  'La madre _____ a sus niños.',
  'En los libros, Waldo es muy _____.',
  'If I eat _____, I’ll still have room for dessert!',
  'Moooooooooo!',
  'Any Friday that is this is supposedly bad luck!',
  'A “knock, knock” is a type!',
  'Edgar Allan Poe is considered one of the greatest of all time!',
  'Opposite of stupid!',
  'You take this when you go on a plane!',
  '“A” is one! So is “B”...and “C”!',
  'I don’t like it when I have a _____ de cabeza!',
  'The basketball player knows how to do this very well!',
  'Don’t want to get stung by one! Ouch!',
  'Opposite of rich.',
  'The stars appear in this at night!',
  'An upper part of the body.',
  'A popular tropical fruit!',
  'La mesera _____ la comida.',
  'Animal that has horns and a beard!',
  'After you wash your clothes, you have to do this to them!',
  'Someday, I want a Lamborghini!',
  'Use it to draw straight lines!',
  'When you drop a plate, it becomes this!',
  'quinto, _____, séptimo',
  'You need one from the computer to the projector.',
  'Ellos _____ los papeles en la basura.',
  'There are these for all countries of the world!',
  '¿_____ tú en extraterrestres?',
  'After he jumped, he fell to the _____!',
  'The Taylor Swift concert was _____ of people!',
  'You hang posters on it!',
  'There are 24 in a day!',
  "It's a great kind of energy to use to preserve the environment!",
  'In the United States, people do this in November.',
  'You can use shingles to build one!',
  'They light these in the cemeteries during Day of the Dead!',
  'Opposite of “to go down”!',
  'A clown can make you one in the shape of something!',
  'These jump on lily pads!',
  'Babies get lots of these!',
  'You’re enrolled in a Spanish one right now!',
  'Christian Bale is one!',
  'They’re not wet, they’re _____!',
  'There is one on the Frosted Flakes box!',
  'A sport where you get in a ring and wear gloves!',
  'Ella está triste y _____.',
  'Turn them on if you’re afraid of the dark!',
  'Opposite of “to go up”!',
  'They’re not cheap, they’re _____!',
  'Mark Twain is a famous one!',
  'Where you clean yourself off!',
  'Amazon sends your packages in these!',
  'Some wedding rings are made of this!',
  'When it gets really cold, this happens!',
  'Area between hills and mountains!',
  'At the grocery store, you put your items in this!',
  'It’s not good to spread one of these about someone!',
  'A very versatile vegetable! You can make fries and chips with them, have them mashed… all sorts of possibilities!',
  'Ellos _____ a las seis de la tarde cada noche.',
  'It’s important to do this a lot every day to stay healthy!',
  'Hawái es un estado muy _____.',
  'Opposite of “to go”!',
  'It’s an _____ to receive an important award!',
  'Opposite of full!',
  'Blue is one! So is purple!',
  'Él _____ en bicicleta.',
  'Learning what your preferences are is a very important _____ of life!',
  'El vendedor _____ muchas cosas bonitas.',
  'Can be a type of movie!',
  'Yo siempre _____ a la escuela a las siete.',
  'So many _____ to do!',
  'OK, that’s _____ already!',
  'Voy a _____ por tu casa a las cuatro.',
  'Yo _____ la calle con mucho cuidado.',
  'Sometimes I like an egg cooked this way!',
  'It makes a honking sound!',
  'You use it a lot in baking!',
  'You drink coffee and tea from them!',
  'El abuelo tiene un _____ adorable. ¡Solo tiene dos años!',
  'He’s cute! Does he have a _____?',
  'A main area of a town could have one!',
  'Paper towels and toilet paper come in these!',
  'Ferdinand is one of these in his own movie!',
  'The balloon _____ in the air!',
  'Opposite of global.',
  'Put one at the end of your sentence!',
  'You have to wait your _____!',
  'To be together in something.',
  'To make cool stuff out of your ideas!',
  'I got scared when I heard a loud _____!',
  'Yo _____ mis propias opiniones.',
  'It’s not _____, but it’ll do.',
  'A’s and B’s are good ones!',
  'I just heard my favorite song on the _____!',
  'The opposite of something being against the law!',
  'People who live in the countryside live in this kind of area.',
  'Hey, could you do me a _____? Pretty please?',
  'Ella _____ muy bien en la película.',
  'Hunter is a popular brand of these.',
  'El estudiante _____ las notas.',
  'The opposite of different!',
  'A body that has been preserved by wrapping it in bandages.',
  'Sometimes it’s important to take a _____ and reflect.',
  'In the fall, these are beautiful!',
  'You are responsible for your own!',
  'Mi amigo _____ mucho a California en avión.',
  'It lives in the ocean and has eight legs!',
  'It’s Tuesday! Time to eat these!',
  'How many _____ do you think that tall building has?',
  'I try to run one of these a day!',
  'My boyfriend gave me a dozen of these for Valentine’s Day!',
  'I can’t decide between the two! I like _____!',
  'A car is made mostly out of this.',
  '10+ years ago, you would have bought music on this!',
  '_____ are invited to my party! Bring your friends!',
  'Mi amigo siempre _____ las consecuencias de sus acciones.',
  'I have five brothers and sisters. My parents had lots of these!',
  'That painting is very famous! It has lots of this!',
  'The _____ of the accident was speeding.',
  'Types include chicken, beef, and pork!',
  'Yo _____ ropa de color rojo hoy.',
  'An important part of a car!',
  'What’s your favorite _____? I like, “That was a piece of cake!”',
  'There are lots of concert ones of these in New York!',
  'A type of shirt',
  'Yo _____ los papeles que no necesito de mi mochila y los tiro en la basura.',
  'You can get these in several sizes like queen or king!',
  'Let’s meet up in the _____ of the park.',
  'You can put one on your face to moisturize it!',
  'Campbell’s makes good ones!',
  'Voy a _____le más sal a la sopa.',
  'Got one from my grandma in the mail!',
  '“¿Hay un restaurante en este pueblo?” “Sí, hay uno _____ al cine, solo a dos minutos de aquí.”',
  'Each arm has one of these!',
  'They are going _____, not with a group of people.',
  'Some are ranches and some are two-story or more!',
  'They dance this in Argentina!',
  'You have two that make up part of your mouth!',
  'Kids can be this sometimes!',
  '“Stop! How many _____ do I have to ask you?!”',
  '“It’s a _____ meeting you!”',
  'El bebé va a _____ en el hospital.',
  'There are lots of farms here!',
  '¡Mira! ¡_____ casas son muy bonitas!',
  'Take these to get around town, especially in big cities!',
  'Los estudiantes _____ que el profesor va a dar el examen el viernes.',
  'Es un día bonito. Voy a _____ un poco por el parque.',
  'I like to have a couple of _____ of milk when I eat cookies!',
  'Watch out for that _____ when you’re driving!',
  'Gotta pay this every month!',
  'That’s not _____! I want the same amount of candy as my brother got!',
  'Go to these to see new releases!',
  'The opposite of “to be born”.',
  'Quack! Quack!',
  'You gotta read each one in a crossword to get the answers!',
  '¡No son altos, son _____!',
  'Queen is a popular rock one of these from the 70’s!',
  'Go on a train through the mountains and you will have a fantastic _____ of natural beauty!',
  'The members of the Addams Family are this!',
  'Tacos, beans, and this all taste great together!',
  '¡Las _____ son instrumentos grandes!',
  'Voy a _____ a Europa en un avión.',
  'Use this or a brush to groom your hair!',
  'I have to have a(n) _____ physical every year to play sports.',
  'Models put makeup on their _____ before a photo shoot!',
  'A bakery has lots of these!',
  'Voy a _____ la fruta a ver cuánto tengo que pagar.',
  'You will see elephants, tightrope walkers, and clowns here!',
  'I hear many different _____ in the choir!',
  'Almond Joy candy bars have this in it!',
  'The Sacramento _____ are an NBA team!',
  '¡Todavía _____ mucha comida de Thanksgiving! (We’re never gonna eat it all!)',
  'Los doctores pueden _____ muchas enfermedades.',
  'The desks are in _____.',
  '¡Ella va a _____ bien en el concierto!',
  'Tú _____ respetar a los profesores.',
  'I’m not doing so hot in math class, I think I’m going to get a _____ to help me.',
  '¡_____ que sí!',
  '¡Cuidado! ¡Los chiles _____ mucho!',
  'I like people with a good sense of _____!',
  'Voy a _____ la basura.',
  'I’ve had different kinds of _____ at both of my jobs. One was nice and one was not!',
  'Dannon is a popular brand!',
  'If you sing in a choir, you sing this type of music!',
  'The dictator has all the _____.',
  'I’m kinda clumsy and do this a lot!',
  'It’s a _____ that getting a good amount of sleep helps you function better!',
  'Ella _____ su número de teléfono.',
  'He doesn’t sing bass in the choir, he sings _____.',
  'These are soooo long at Disney World!',
  'There’s a _____ of people who signed up to play, so we’re going to cancel it.',
  'Es importante no _____ tu teléfono en la clase.',
  'Lots of different languages are spoken all throughout the _____!',
]
